import icons from './icons.json'
import { dialogLabels } from '~/contents/benefits'

const flexNeedToKnow = [
	"Your HMO ID contains your member ID you present at the hospital to access care. It's important to keep your ID number handy or written out somewhere, as it is required for treatment at any of the listed hospitals under your plan.",
	"You unlock more benefits when you constantly renew your subscription. If you fail to renew, your benefits reset, and you'll only have access to the initial benefits available from the 1st month when you renew the plan.",
	'Any treatments, tests, procedures, and benefits not listed are not covered, and we will not bear liability for them.',
	'This is an insurance product, and it adheres to standard insurance procedures.',
	'This plan is a periodic subscription that renews automatically for card transactions as long as the registered card is funded. Upon expiry, the payment will be deducted from your registered card or funded wallet.',
	'Please note that the plan does not cover certain exclusions.',
	'When you or your staff arrive at any of the hospitals, tell them you are from Hygeia. If you experience any delay, call 09070008899'
]

const howToGetCoveredHealth = [
	'Purchase the plan, and activate your policy.',
	'After activation, your e-HMO ID will be automatically generated and sent to you.',
	'Present your HMO ID at any of the available hospitals under your plan to receive healthcare.'
]
const config = {
	short_description: 'This plan provides you with instant access to high-quality healthcare.',
	description: 'FlexiCare Mini covers you and your staff with quality health care',
	product_title: 'Unlock access to quality health cover',
	card_label:
		'Enjoy up to ₦700,000 coverage. Surgeries and maternity care available at mcg_price per staff. Affordable and reliable medical plan.',
	dialogLabels
}
export const flexicare_mini: Record<'hygeia' | 'bastion', Partial<BenefitStoreContext[string]>> = {
	bastion: {
		...config,
		short_benefits: {
			'Need To Know': {
				icon: icons.need_to_know,
				isOpen: true,
				value: [
					"Your HMO ID contains your member ID you present at the hospital to access care. It's important to keep your ID number handy or written out somewhere, as it is required for treatment at any of the listed hospitals under your plan.",
					'Any treatments, tests, procedures, and benefits not listed are not covered, and we will not bear liability for them.',
					'This is an insurance product, and it adheres to standard insurance procedures.',
					'This plan is a periodic subscription that renews automatically for card transactions as long as the registered card is funded. Upon expiry, the payment will be deducted from your registered card or funded wallet.',
					'Please note that the plan does not cover certain exclusions.',
					'When you or your staff arrive at any of the hospitals, tell them you are from Hygeia. If you experience any delay, call 09070008899'
				]
			},
			'Total Hospitals': {
				icon: icons.hospital,
				isOpen: false,
				key: 'hospital',
				value: [
					{
						text: 'Your staff gains access to over 1200 hospitals across Nigeria.'
					}
				]
			},
			'Your Business Will Enjoy': {
				icon: icons.business,
				isOpen: false,
				value: [
					'Treatment of everyday illnesses, like malaria and more.',
					'Access to different types of surgeries worth up to ₦70,000.',
					'Coverage for delivery and ante-natal care up to ₦50,000.',
					'Specialist consultation.'
				]
			}
		},
		allBenefits: {
			dialog: {
				benefits: [
					'General & Specialist Consultations: Includes O&G, Pediatrician, Surgeon, Cardiothoracic Surgeon, Neurosurgeon, ENT Surgeon, Urologist, Orthopedic Surgeon, Gastroenterologist, Cardiologist, Neurologist, Nephrologist, Psychiatrist, and Neonatologist.',
					'Telemedicine Services: 24/7 access to free chats with doctors and nurses.',
					'Family Planning: Covered up to ₦7,000 annually for contraceptives and implants.',
					'Immunization (0-5 years): Includes BCG, OPV, DPT, measles. Other vaccines like Vitamin A, Yellow Fever, and Meningitis are not covered.',
					'Laboratory Tests: Limited to basic hematology, chemistry, microbiology, and serology.',
					'In-Patient Care: General ward admissions and accommodation covered for up to 10 days annually, up to the inpatient limit.',
					'Eye Care: Routine eye tests and treatment of acute eye diseases covered up to ₦5,000. Lenses and frames are not covered.',
					'Dental Care: Primary dental care covered up to ₦5,000 annually. Secondary care includes procedures like extractions and root canal therapy, covered within the overall dental limit.',
					'Physiotherapy: Covered up to ₦10,000 annually.',
					'Surgeries: Coverage for minor, intermediate, and major surgeries up to ₦70,000.',
					'Obstetrics Care: Ante-natal care, normal and assisted deliveries, covered up to ₦50,000.',
					'Neonatal Care: Male circumcision and ear piercing covered.',
					'Wellness Checks: Includes BMI, general physical examination, hypertension, and diabetes screenings.',
					'HIV Care & Treatment: Includes specialist consultations and drug therapy, up to the pharmacy limit.',
					'Psychiatry Care: Coverage for mental illnesses. 1 session up to ₦10,000.',
					'Diagnosis & Line of Treatment: Second opinion covered within the HMO network based on eligible providers.'
				],
				need_to_know: [
					"Your HMO ID contains your member ID you present at the hospital to access care. It's important to keep your ID number handy or written out somewhere, as it is required for treatment at any of the listed hospitals under your plan.",
					'Any treatments, tests, procedures, and benefits not listed are not covered, and we will not bear liability for them.',
					'This is an insurance product, and it adheres to standard insurance procedures.',
					'This plan is a periodic subscription that renews automatically for card transactions as long as the registered card is funded. Upon expiry, the payment will be deducted from your registered card or funded wallet.',
					'Please note that the plan does not cover certain exclusions.',
					'When you or your staff arrive at any of the hospitals, tell them you are from Hygeia. If you experience any delay, call 09070008899'
				],
				'How to get covered': [
					'Purchase the plan, and activate your policy.',
					'After activation, your e-HMO ID will be automatically generated and sent to you.',
					'Present your HMO ID at any of the available hospitals under your plan to receive healthcare.'
				]
			}
		}
	},
	hygeia: {
		...config,
		short_benefits: {
			'Need To Know': {
				icon: icons.need_to_know,
				isOpen: true,
				value: flexNeedToKnow
			},
			'Total Hospitals': {
				icon: icons.hospital,
				isOpen: false,
				value: [
					{
						text: 'Your staff gains access to over 1200 hospitals across Nigeria.'
					}
				]
			},
			'Your Business Will Enjoy': {
				icon: icons.business,
				isOpen: false,
				value: [
					'Treatment of everyday illnesses, like malaria and more.',
					'Access to different types of surgeries worth up to ₦70,000.',
					'Coverage for delivery and ante-natal care up to ₦50,000.',
					'Specialist consultation.'
				]
			}
		},
		allBenefits: {
			dialog: {
				benefits: [
					'General & Specialist Consultations: Includes O&G, Pediatrician, Surgeon, Cardiothoracic Surgeon, Neurosurgeon, ENT Surgeon, Urologist, Orthopedic Surgeon, Gastroenterologist, Cardiologist, Neurologist, Nephrologist, Psychiatrist, and Neonatologist.',
					'Telemedicine Services: 24/7 access to free chats with doctors and nurses.',
					'Family Planning: Covered up to ₦7,000 annually for contraceptives and implants.',
					'Immunization (0-5 years): Includes BCG, OPV, DPT. Other vaccines like Vitamin A, Measles, Yellow Fever, Meningitis are not covered.',
					'Laboratory Tests: Limited to basic hematology, chemistry, microbiology, and serology.',
					'In-Patient Care: General ward admissions and accommodation covered for up to 10 days annually, up to the inpatient limit.',
					'ENT Care: Specialist consultations and treatments for acute and chronic ENT diseases covered.',
					'Eye Care: Routine eye tests and treatment of acute eye diseases covered up to ₦5,000. Lenses and frames not covered.',
					'Dental Care: Primary dental care covered up to ₦5,000 annually. Secondary care includes procedures like extractions and root canal therapy, covered within the overall dental limit.',
					'Physiotherapy: Covered up to ₦15,000 annually.',
					'Surgeries: Coverage for minor, intermediate, and major surgeries up to ₦70,000.',
					'Obstetrics Care: Ante-natal care, normal and assisted deliveries, covered up to ₦50,000.',
					'Neonatal Care: Male circumcision and ear piercing not covered.',
					'Wellness Checks: Includes BMI, general physical examination, hypertension, and diabetes screenings.',
					'Ambulance Services: Covered for outpatient only, within the first 4 weeks.',
					'HIV Care & Treatment: Includes specialist consultations and drug therapy, up to the pharmacy limit.',
					'Psychiatry Care: Coverage for mental illnesses under telemedicine.',
					'Diagnosis & Line of Treatment: Second opinion covered within the HMO network based on eligible providers.'
				],
				need_to_know: flexNeedToKnow,
				'How to get covered': howToGetCoveredHealth
			}
		}
	}
}
